// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__zxFrj","Cancel":"schedule_Cancel__ivOIF"};